/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import Slider from 'react-slick';
import { makeStyles } from '@material-ui/core/styles';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';

const Arrow = (props) => {
  const {
    style,
    onClick,
    icon: Icon,
  } = props;

  const useStyles = makeStyles((theme) => ({
    root: {
    },
    cardContent: {
      padding: 0,
    },
    slickArrow: {
      ...theme.home.sliderArrow,
    },
  }));

  const classes = useStyles();

  return (
    <div className="slick-arrow" style={{ ...style }} onClick={onClick}>
      <Icon fontSize="large" className={classes.slickArrow} color="primary" />
    </div>
  );
};

const Carousel = (props) => {
  const {
    autoplay = false,
    fade = false,
    dots = false,
    speed = 500,
    arrows = true,
    infinite = true,
    lazyLoad = '',
    slidesToShow = 1,
    slidesToScroll = 1,
    slidesPerRow = 1,
    rows = 1,
    responsive,
    children,
    className,
  } = props;
  return (
    <Slider
      autoplay={autoplay}
      fade={fade}
      dots={dots}
      arrows={arrows}
      infinite={infinite}
      slidesToShow={slidesToShow}
      slidesToScroll={slidesToScroll}
      slidesPerRow={slidesPerRow}
      rows={rows}
      speed={speed}
      lazyLoad={lazyLoad}
      nextArrow={<Arrow icon={ArrowForwardIosIcon} />}
      prevArrow={<Arrow icon={ArrowBackIosIcon} />}
      responsive={responsive}
      className={className}
    >
      {children}
    </Slider>
  );
};

export default Carousel;
